import { Box, Typography, useTheme } from "@mui/material";
import { useState } from "react";
import CustomSwitch from "../../components/CustomSwitch";

/**
 * Demo component for CustomSwitch
 * Shows different states and configurations of the CustomSwitch component
 */
const CustomSwitchDemo = () => {
  const [checked, setChecked] = useState(false);
  const theme = useTheme();

  return (
    <Box display="flex" flexDirection="column" gap={1}>
      <Box display="flex" alignItems="center" gap={1}>
        <CustomSwitch
          checked={checked}
          onChange={(e) => setChecked(e.target.checked)}
        />
        <Typography variant="body2">Basic Switch</Typography>
      </Box>
      <Box display="flex" alignItems="center" gap={1}>
        <CustomSwitch
          checked={checked}
          onChange={(e) => setChecked(e.target.checked)}
          tooltipTitle="Toggle me"
        />
        <Typography variant="body2">With Tooltip</Typography>
      </Box>
      <Box display="flex" alignItems="center" gap={1}>
        <CustomSwitch
          checked={checked}
          onChange={(e) => setChecked(e.target.checked)}
          disabled={true}
        />
        <Typography variant="body2">Disabled</Typography>
      </Box>
    </Box>
  );
};

export default CustomSwitchDemo;
